import { Button } from '@aecom-ai-engineering/react-components';
import { useMyUser } from '@consigli/hooks';
import { Plus } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Route } from '@/routes';

interface NewProjectButtonProps {
  /** The header instance needs `shrink-0`; the empty state does not. */
  className?: string;
}

/**
 * Renders nothing for a user with no organization, who cannot create projects.
 *
 * The plus sits before the label because the design's button node puts its icon
 * on the left and hides the right slot. Button.css sizes a direct `> svg` child,
 * so it goes in as a child rather than through a prop.
 */
export const NewProjectButton: FC<NewProjectButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  const { user } = useMyUser();
  const { t } = useTranslation();

  if (!user.organizationId) {
    return null;
  }

  return (
    <Button
      className={className}
      onClick={() => navigate(`/${Route.NEW_PROJECT}`)}
      size="md"
      variant="solid"
    >
      <Plus aria-hidden="true" />
      {t('project-creation.create-project')}
    </Button>
  );
};
